/* eslint-disable no-console */
/* eslint-disable max-len */
import { Box, Stack, Tooltip } from '@mui/material';
import React, { useContext } from 'react';
import ReactionPopover from './ReactionPopover';
import { IoChatboxEllipses, IoChatboxOutline } from 'react-icons/io5';
import { LanguageContext } from '../../../../../../libs/Context';
import { useSelector } from 'react-redux';
import { updateReaction } from '../../../../../actions/feeds_actions_new';
import { toast } from 'react-toastify';
import { catchErr } from '../../../../../../libs/HelperContent';
import { reactions } from '..';
import { FaHeart, FaStar } from 'react-icons/fa';
import ReactionView from './ReactionView';

const DEFAULT_REACTION_IMG = '/images/icons/smily.svg';

const ReactionSlector = (props:any) =>
{
	const {	eventState, handleClose, handleOpenComment, handleClick, setEventState, getEventsData } = props;
	const { language } = useContext(LanguageContext);
	const session = useSelector((state: any) => state?.mysession?.session);
	const { isLoading, openComment, openReaction, reactionImg, anchorEl, reactionData, selectedEvent } = eventState;
	const open:any = Boolean(anchorEl);

	// Update Reaction
	const handleUpdateReaction = async (reaction:any, eventId:any) =>
	{
		if (Object.keys(selectedEvent)?.length > 0 && selectedEvent?.reactionData?.length > 0 && selectedEvent?.reactionData[0]?.type === reaction) return;
		if (!isLoading)
		{
			const body = {
				id   : eventId,
				type : reaction,
				name : session?.name
			};

			try
			{
				const res = await updateReaction(body);

				if (res?.status)
				{
					toast.success(language.reactionsUpdatedSuccessfully);
					const foundReaction = reactions.find((react) => react?.key === reaction);

					setEventState((prev:any) => ({ ...prev,
						reactionImg  : foundReaction?.imgSrc || DEFAULT_REACTION_IMG,
						reactionData : res?.data
					}));
					await getEventsData();
				}
				else
				{
					toast.error(language.failedToUpdateReaction);
					setEventState((prev:any) => ({
						...prev,
						reactionImg  : prev?.reactionImg,
						reactionData : prev?.reactionData

					}));
				}
			}
			catch (error)
			{
				catchErr(error);
			}
			finally
			{
				setEventState((prev:any) => ({ ...prev, isLoading: false }));
			}
		}
	};
	const handleReaction = (reaction:any, eventId:any) =>
	{
		handleUpdateReaction(reaction, eventId);
		handleClose();
	};
	const handleOpenReaction = () =>
	{
		setEventState((prev:any) => ({ ...prev, openReaction: true, openComment: false }));
	};

	const selectedImg = reactions?.find((reaction) => reaction?.key === reactionData?.type);

	const reactionsType = selectedEvent?.reactionData?.length > 0 ? selectedEvent?.reactionData?.map((each) => each?.type) : [];

	const reactionsData = reactionsType?.length > 0 ? reactions?.filter((each) => reactionsType.includes(each?.key)) : [];

	return (
		<>
			<Stack direction='row' justifyContent='space-between' alignItems='center' spacing={1}>
				<Stack direction='row' alignItems='flex-start' spacing={2} pt='var(--pixel12)'>
					{/* Reaction Selector */}
					<Box
						height='var(--pixel22)'
						width='var(--pixel22)'
						display='flex'
						className='reaction-button'
						sx={{ cursor: 'pointer' }}
						onClick={handleClick}
					>
						<img
							src={reactionImg ?? selectedImg?.imgSrc}
							alt={reactionData?.type || (selectedEvent?.reactionData?.length > 0 ? selectedEvent.reactionData[0].type : 'smile')}
						/>
					</Box>
					{/* Popover */}
					{open && (
						<ReactionPopover
							open={open}
							eventState={eventState}
							onReactionClick={(reactionKey) => handleReaction(reactionKey, selectedEvent?.eventId)}
							setEventState={setEventState}
						/>
					)}
					{/* Comments Section */}
					<Tooltip title={language?.comments} placement='top'>
						<Box sx={{ marginRight   : 0.5,
							cursor        : 'pointer',
							color         : '#536471',
							'&:hover svg' : {
								backgroundColor : 'transparent',

								color     : '#23A4C4',
								transform : 'scale(1.2)'
							}
						}} onClick={handleOpenComment} display='flex'
						>
							{!openComment ? <IoChatboxOutline fontSize='var(--pixel24)'/> : <IoChatboxEllipses style={{ fontSize: 'var(--pixel24)', color: 'var(--primaryColor)' }} />}
						</Box>
					</Tooltip>
				</Stack>
				<Stack direction='row' spacing={-1} pt='var(--pixel12)' sx={{ cursor: 'pointer' }} onClick={handleOpenReaction}>
					{reactionsData?.length > 0 &&
					reactionsData?.slice(0, 2).map((each) => (
						<Box
							key={each?.key}
							sx={{
								display         : 'flex',
								alignItems      : 'center',
								justifyContent  : 'center',
								width           : 24,
								height          : 24,
								border          : '1px solid #FFC107',
								borderRadius    : 'var(--percent50)',
								backgroundColor : 'white'
							}}
						>
							<img src={each?.imgSrc} alt={each?.alt} width={18} height={18}/>
						</Box>
					))
					}
					{reactionsData?.length > 2 &&
					<Box
						sx={{
							display         : 'flex',
							alignItems      : 'center',
							justifyContent  : 'center',
							width           : 24,
							height          : 24,
							border          : '1px solid #3498DB',
							borderRadius    : 'var(--percent50)',
							backgroundColor : 'white',
							color           : '#3498DB',
							fontSize        : '0.8rem',
							fontWeight      : 'bold'
						}}
					>
						+{reactionsData?.length - 2}
					</Box>
					}
				</Stack>
			</Stack>
			{openReaction && (
				<ReactionView
					key={selectedEvent?.eventId}
					getData={selectedEvent}
					postData={reactionData}
					setEventState={setEventState}
				/>
			)}

		</>
	);
};

export default ReactionSlector;